import { Form } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useResetPasswordWithPhoneMutation } from "apis/services/auth";
import Text from "components/general/Text";
import TextInput from "components/inputs/TextInput";
import Button from "components/general/Button";
import showSuccessMsg from "utils/showSuccessMsg";
import styles from "./styles.module.scss";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [createNewPassword, { isLoading }] =
    useResetPasswordWithPhoneMutation();

  const handleSubmit = (values: { code: string }) => {
    createNewPassword({
      ...values,
      phone: searchParams.get("phone"),
      code: searchParams.get("code"),
    })
      .unwrap()
      .then(() => {
        showSuccessMsg({ msg: "Your password has been reset." });
        navigate(`/auth`);
      });
  };

  return (
    <>
      <Text className={styles.title}>Forgot password</Text>
      <Text className={styles.secondaryTitle}>Enter your new password</Text>
      <Form
        className={styles.form}
        autoComplete="off"
        autoCorrect="off"
        onFinish={handleSubmit}
      >
        <Form.Item name="password" rules={[{ required: true }]}>
          <TextInput label="New Password" type="password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <TextInput label="Confirm new password" type="password" />
        </Form.Item>

        <Button
          btnClassName={styles.submitBtn}
          isLoading={isLoading}
          type="submit"
        >
          Submit
        </Button>
      </Form>
    </>
  );
}
